import { Button, Group, Stack, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

import { ReportForm } from '../components/ReportForm';
import { ReportsTable } from '../components/ReportsTable';

import { usePermissions } from '@/features/auth';

export const AiReportsPage = () => {
  const { can } = usePermissions();
  const isPromptEditor = can('ai-reports:prompts');

  return (
    <Stack p="md" gap="lg">
      <Group justify="space-between">
        <Title order={2}>AI-reports</Title>
        {isPromptEditor && (
          <Button component={Link} to="/ai-reports/prompts" variant="default">
            Настройки промта
          </Button>
        )}
      </Group>
      <ReportForm />
      <ReportsTable />
    </Stack>
  );
};
